import React from 'react';
import CountdownComponent, { zeroPad } from 'react-countdown';

const RenderCountdown = ({ hours, minutes, seconds }) => {
    return (
        <span>
            {hours}:{zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
    );
};

const Countdown = (props) => {
    return (
        <CountdownComponent
            date={props.eventStart}
            renderer={RenderCountdown}
        />
    );
};

export default Countdown;
